(function(){
    angular
        .module('element-menu-if-else.dir', [])
        .directive('elementMenuIfElse', ['$rootScope','$timeout', '$compile',elementMenuIfElse]);

    function elementMenuIfElse($rootScope, $timeout, $compile){
        return {
            scope: {},
            templateUrl: 'app/views/templates/elements-menu-if-else.tpl.html',
            controller: ['$scope', '$http', '$sce', function($scope, $http, $sce){
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.actionList = true;

                //Function to Display Menu options on the view: Action / Condition
                function onDataComplete(response) {
                    $scope.menu = response.data;
                };

                function onError(reason) {
                    $scope.error = 'Could not load the list';
                };

                $http.get("app/services/mocks/elementMenuIfElse.json")
                    .then(onDataComplete, onError);
                //

                $scope.selectedPanel = function($event){
                    //Controller resources: Wrap, Action and Condition List
                    var wrap = $('.wrap');
                    var currentSelection = $event.target.id;

                    //adding Class active to the wrap, to be moved to the left to display panels
                    wrap.addClass('active');

                };

                $scope.selectedOption = function(option){
                    $scope.$emit('selectedOption', option, $scope.$parent.connections.id);
                };
            }]
        }

    }

}());



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/element-menu-if-else.js